<template>
  <ul :class="prefixBreadcrumbClass">
    <slot></slot>
  </ul>
</template>
<script>
import * as constants from '../../utils/constants'

const PREFIX_BREADCRUMB_CLASS = `${constants.PREFIX_CLASS}breadcrumb`

export default {
  name: 'Tbreadcrumb',
  props: {
    separator: {
      type: String,
      default: '/'
    }
  },
  computed: {
    prefixBreadcrumbClass() {
      return PREFIX_BREADCRUMB_CLASS
    }
  },
  watch: {
    separator() {
      this.$_updateChildren()
    }
  },
  mounted() {
    this.$_updateChildren()
  },
  updated() {
    this.$nextTick(() => {
      this.$_updateChildren()
    })
  },
  methods: {
    $_updateChildren() {
      this.$children.forEach(child => {
        child.separator = this.separator;
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// breadcrumb.vue?3fc6eb65